import React from 'react'
import Svg from '../../../common/Svg'

const CustomInput = ({ fieldData, formikData, submitResponseCallback, numbering }) => {
    const language = localStorage.getItem('customer_language') ?? '22'

    const order = fieldData.su_order_no
    const questionId = fieldData.su_question_id
    const id = `${fieldData.add_date_time}${Math.random()}`
    const title = fieldData.su_question_text && JSON.parse(fieldData.su_question_text)[language]
    const hint = fieldData.su_question_hint && JSON.parse(fieldData.su_question_hint)[language]
    const options = fieldData.su_options && JSON.parse(fieldData.su_options) && JSON.parse(fieldData.su_options)['optionsText'] && JSON.parse(fieldData.su_options)['optionsText'][language]


    //Formik
    const { values, touched, errors, setFieldValue, setFieldTouched } = formikData
    const handleRadioButtons = (e, key) => {
        setFieldTouched(key, true)
        setFieldValue(key, e.target.value)
        submitResponseCallback(key, e.target.value)
    }
    return (
        <div className="question-inner question-wrap question-type-radio">
            {hint && <div className="custom-tooltip-wrap">
                <div className="icon-wrap">
                    <Svg name="info-icon" />
                </div>
                <div className="text-wrap">
                    <p>{hint}</p>
                </div>
            </div>}

            <div className="heading" question-count={numbering} dangerouslySetInnerHTML={{ __html: title }}></div>
            <div className="answer-options answerOptions-wrap bark-color">
                {
                    Object.keys(options ?? {}).map((key) => {
                        return (
                            <div className="form-check" key={`${id}${key}`}>
                                <input
                                    type="radio"
                                    className="form-check-input"
                                    name={questionId}
                                    id={`${id}${key}`}
                                    onChange={(e) => handleRadioButtons(e, questionId)}
                                    data-score={10}
                                    value={key}
                                    checked={values[questionId] === key}
                                    autoComplete="new-input"
                                />

                                <label className="form-check-label" htmlFor={`${id}${key}`}>
                                    <span>{options[key]}</span>
                                </label>
                            </div>
                        )
                    })
                }
            </div>
            {touched[questionId] && errors[questionId] && <div className="error-message">
                <Svg name="error-icon" />
                <p>Please select an answer for this question to continue</p>
            </div>}
        </div >
    )
}

export default CustomInput